export const CANONICAL_ORIGIN = 'https://clientalio.com';

export const CROSS_DOMAIN_LINKER_DOMAINS = [
  'clientalio.com',
  'app.clientalio.com'
];

export const REFERRAL_EXCLUSION_DOMAINS = [
  'accounts.google.com',
  'mail.google.com',
  'pay.google.com',
  'checkout.razorpay.com',
  'razorpay.com'
];

export const UTM_CAMPAIGN_PRESETS = {
  linkedin: { utm_source: 'linkedin', utm_medium: 'social' },
  instagram: { utm_source: 'instagram', utm_medium: 'social' },
  reddit: { utm_source: 'reddit', utm_medium: 'social' },
  x: { utm_source: 'x', utm_medium: 'social' },
  facebook: { utm_source: 'facebook', utm_medium: 'social' },
  email: { utm_source: 'email', utm_medium: 'email' },
  googleAds: { utm_source: 'google', utm_medium: 'cpc' },
  blog: { utm_source: 'blog', utm_medium: 'content' },
  productLaunch: { utm_source: 'owned', utm_medium: 'product' }
};

const STORAGE_KEY = 'clientalioAttribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
const CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id'];

const getStorage = () => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const readStoredAttribution = () => {
  const storage = getStorage();
  if (!storage) return null;

  try {
    return JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
};

const writeStoredAttribution = (value) => {
  const storage = getStorage();
  if (!storage) return;
  storage.setItem(STORAGE_KEY, JSON.stringify(value));
};

const getQueryAttribution = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const attribution = {};

  [...UTM_KEYS, ...CLICK_ID_KEYS].forEach((key) => {
    const value = params.get(key);
    if (value) {
      attribution[key] = value;
    }
  });

  return attribution;
};

export const captureAttribution = () => {
  if (typeof window === 'undefined') return null;

  const queryAttribution = getQueryAttribution();
  const stored = readStoredAttribution();
  const hasCampaignData = Object.keys(queryAttribution).length > 0;
  const now = new Date().toISOString();

  if (!hasCampaignData && stored) {
    return stored;
  }

  const nextAttribution = {
    first_touch: stored?.first_touch || (hasCampaignData ? { ...queryAttribution, captured_at: now } : null),
    last_touch: hasCampaignData ? { ...queryAttribution, captured_at: now } : stored?.last_touch || null,
    landing_page: stored?.landing_page || `${window.location.pathname}${window.location.search}${window.location.hash}`,
    referrer: stored?.referrer || document.referrer || null
  };

  if (hasCampaignData || !stored) {
    writeStoredAttribution(nextAttribution);
  }

  return nextAttribution;
};

export const getAttributionEventParams = () => {
  if (typeof window === 'undefined') return {};

  const attribution = captureAttribution();
  const lastTouch = attribution?.last_touch || attribution?.first_touch;

  if (!lastTouch) return {};

  return Object.fromEntries(
    UTM_KEYS
      .filter((key) => lastTouch[key])
      .map((key) => [`traffic_${key.replace('utm_', '')}`, lastTouch[key]])
  );
};

export const buildUtmUrl = (url, sourceOrPreset, campaign, options = {}) => {
  const preset = UTM_CAMPAIGN_PRESETS[sourceOrPreset] || { utm_source: sourceOrPreset };
  const target = new URL(url, CANONICAL_ORIGIN);
  const params = {
    ...preset,
    utm_campaign: campaign,
    ...options
  };

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      target.searchParams.set(key, value);
    }
  });

  return target.toString();
};
